import { render, staticRenderFns } from "./DialogQuestionPreview.vue?vue&type=template&id=8d0c1ccc&scoped=true"
import script from "./DialogQuestionPreview.vue?vue&type=script&lang=js"
export * from "./DialogQuestionPreview.vue?vue&type=script&lang=js"
import style0 from "./DialogQuestionPreview.vue?vue&type=style&index=0&id=8d0c1ccc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0c1ccc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d0c1ccc')) {
      api.createRecord('8d0c1ccc', component.options)
    } else {
      api.reload('8d0c1ccc', component.options)
    }
    module.hot.accept("./DialogQuestionPreview.vue?vue&type=template&id=8d0c1ccc&scoped=true", function () {
      api.rerender('8d0c1ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogQuestionPreview.vue"
export default component.exports